import i18n from "../../../../../constants/i18n";
import getKhattabatMatchingStore from "../../../../../stores/khattabat-stores/matching-stores";
import { TEt3PickerMultipleValue } from "../../../../../TypesNEW";
import Et3Button from "../../../../../core/et3-button";
import ET3Div from "../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import Et3Picker from "../../../../../core/et3-input/et3-picker";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import FormSectionWrapper from "./FormSectionWrapper";

const CitySearch = withLiteObserverAndTheme(() => {
  const shouldShow =
    getKhattabatMatchingStore().isCitySearchAvailable.get() &&
    !getKhattabatMatchingStore().isChosenResidenceCountriesExcluded.get();

  return !shouldShow ? null : (
    <FormSectionWrapper>
      <ET3Div
        width={700}
        height={100}
        alignItems={"flex-start"}
        fDirection={"row"}
        style={{}}
        color={""}
        justifyContent={"flex-start"}
        withShadow={false}
        isExtendable={false}
        isScrollable={false}
        onClick={() => {}}
      >
        <Et3Picker
          label={i18n.get("CITY_OF_RESIDENCE")}
          options={getKhattabatMatchingStore().availableCityOptions.get()}
          value={getKhattabatMatchingStore().matchResidenceCityFilter.get()}
          onChoose={(value: TEt3PickerMultipleValue) => {
            getKhattabatMatchingStore().setMatchResidenceCityFilter(value);
          }}
          isMultiple={true}
          style={{ position: "relative" }}
          onEnter={() => {}}
          onClick={() => {}}
          containerStyle={{}}
        />
        <Et3Margin top={0} bottom={0} left={20} right={0} />
        <ET3Div
          width={300}
          height={100}
          alignItems={"center"}
          fDirection={"row"}
          style={{}}
          color={""}
          justifyContent={"flex-start"}
          withShadow={false}
          isExtendable={false}
          isScrollable={false}
          onClick={() => {}}
        >
          <Et3Button
            isEnabled={true}
            onClick={async () => {
              getKhattabatMatchingStore().getAvailableCities();
            }}
            size="LARGE"
            type="GET"
            text="GET_CITIES"
          />
        </ET3Div>
      </ET3Div>
    </FormSectionWrapper>
  );
});

export default CitySearch;
